/**
 * This file is to map delay condition , from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import {
	ConditionEvents,
	ActionEvents,
} from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import store from "assets/js/store";
import {
	convertSecondsToNearestUnit,
	convertTimeWithUnitToSeconds,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import {
	getEdge,
	getEndCoachmarkNode,
	getNextTarget,
	getShadowsForStep,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import {
	getValudOfVariable,
	getValueFromIntFunction,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import * as moment from "moment-timezone";
import { I18n } from "react-redux-i18n";

const MIN_DELAY = "48 Hours";
const DELAY_BETWEEN_CHECK_CYCLES = 86400;

const parseBEABTestToFE = (automation, mainStep, subStep, targetId) => {
	const pathARepresentableStep = automation.sub_automations
		.filter((sub) => sub.name == "pathA")[0]
		.steps.filter((step) => step.name == "pathA")[0];
	const pathBRepresentableStep = automation.sub_automations
		.filter((sub) => sub.name == "pathB")[0]
		.steps.filter((step) => step.name == "pathB")[0];
	const pathInternalWinnerRepresentableStep = automation.sub_automations
		.filter((sub) => sub.name == "internal_winner01")[0]
		.steps.filter((step) => step.name == "fallback")[0].args.switch[0];
	const winnerFallback = pathInternalWinnerRepresentableStep.steps[0].args
		.params?.step
		? pathInternalWinnerRepresentableStep.steps[0].args.params?.step
		: pathInternalWinnerRepresentableStep.steps[0].args.sub_automation ==
		  "emit_next_step"
			? null
			: pathInternalWinnerRepresentableStep.steps[0].args.sub_automation;
	const endDateFallback = getValudOfVariable(
		pathInternalWinnerRepresentableStep.condition.gt.value
	)
		.replace("int(", "")
		.replace(")", "");

	// figure out splitting values
	const splittingSteps = automation.sub_automations
		.filter((sub) => sub.name == "n1234")[0]
		.steps.filter((step) => step.name == "n1234")[0].args.switch;

	const pathASplitCondition = splittingSteps.filter(
		(step) => step.steps[0].name == "pathA"
	)[0];
	const pathBSplitCondition = splittingSteps.filter(
		(step) => step.steps[0].name == "pathB"
	)[0];
	const pathWinnerSplitCondition = splittingSteps.filter(
		(step) => step.steps[0].name == "winner"
	)[0];

	const winnerArray = JSON.parse(
		pathWinnerSplitCondition.condition.eq.var.split("in ")[1].replace("}", "")
	);
	const distributionWinner = winnerArray.length * 10;

	const events = [];

	events.push({
		id: mainStep.name,
		position: {
			x: 0,
			y: 0,
		},
		data: {
			name: ConditionEvents()[3].name,
			desc: ConditionEvents()[3].desc,
			type: "condition",
			tileTitle: ConditionEvents()[3].tileTitle,
			id: mainStep.name,
			baseId: "abTest",
			initialElement: false,
			systemAB: true,
			systemWinnerTest: true,
			distributionA: "50",
			distributionB: "50",
			distributionWinner: distributionWinner,
			distributionTest: 100 - distributionWinner,
			systemWinner: true,
			winnerFallback: winnerFallback,
			endDateFallback: moment.unix(endDateFallback).format(),
			shadows: getShadowsForStep(automation, mainStep.name),
		},
		type: "editorNode",
	});
	// Add pathA and pathB events
	events.push({
		id: "pathA",
		type: "editorNode",
		position: {
			x: 0,
			y: 0,
		},
		data: {
			showHeader: false,
			internal: true,
			name: I18n._translate(
				"app-automations-events-abtests-settings-title-email-a"
			),
			desc: ActionEvents()[0].desc,
			type: "action",
			tileTitle: "app-automations-events-abtests-settings-title-email-a",
			id: mainStep.name,
			actionName: pathARepresentableStep.description,
			baseId: "sendEmail",
			sendToLabel: I18n._translate("app-automation-editor-sendEmail-to-grpA"),
			shadows: getShadowsForStep(automation, pathARepresentableStep.name),
			email: {
				content: {
					id: pathARepresentableStep.args.content.id,
					subject: pathARepresentableStep.args.subject,
					html: null,
					text: null,
					json: {},
					type: "bee",
				},
				sender: {
					id: pathARepresentableStep.args.sender?.id,
				},
				thumbnailUrl: pathARepresentableStep.args.thumbnail,
				initialElement: false,
			},
		},
	});
	events.push({
		id: "pathB",
		type: "editorNode",
		showHeader: false,
		position: {
			x: 0,
			y: 0,
		},
		data: {
			internal: true,
			name: I18n._translate(
				"app-automations-events-abtests-settings-title-email-b"
			),
			desc: ActionEvents()[0].desc,
			type: "action",
			tileTitle: "app-automations-events-abtests-settings-title-email-b",
			id: mainStep.name,
			actionName: pathBRepresentableStep.description,
			baseId: "sendEmail",
			sendToLabel: I18n._translate("app-automation-editor-sendEmail-to-grpB"),
			shadows: getShadowsForStep(automation, pathBRepresentableStep.name),
			email: {
				content: {
					id: pathBRepresentableStep.args.content.id,
					subject: pathBRepresentableStep.args.subject,
					html: null,
					text: null,
					json: {},
					type: "bee",
				},
				sender: {
					id: pathBRepresentableStep.args.sender?.id,
				},
				thumbnailUrl: pathBRepresentableStep.args.thumbnail,
				initialElement: false,
			},
		},
	});
	const links = [];
	links.push(
		getEdge("branchingEdge", mainStep.name, "pathA", {
			branchLabel: "pathA",
			hideAddBtn: true,
		})
	);
	links.push(
		getEdge("branchingEdge", mainStep.name, "pathB", {
			branchLabel: "pathB",
			hideAddBtn: true,
		})
	);
	// Check for winners
	if (automation.statsC?.groupedByContact?.sent > 0) {
		const pathCRepresentableStep = automation.sub_automations
			.filter((sub) => sub.name == "pathC")[0]
			.steps.filter((step) => step.name == "pathC")[0];
		events.push({
			id: "pathC",
			type: "editorNode",
			position: {
				x: 0,
				y: 0,
			},
			data: {
				showHeader: false,
				internal: true,
				name: ActionEvents()[0].name,
				desc: ActionEvents()[0].desc,
				type: "action",
				tileTitle: "app-automation-editor_events_action-1_tileTitle",
				id: mainStep.name,
				actionName: pathCRepresentableStep.description,
				baseId: "sendEmail",
				sendToLabel: I18n._translate("app-automation-editor-sendEmail-to-ppl"),
				email: {
					content: {
						id: pathCRepresentableStep.args.content.id,
						subject: pathCRepresentableStep.args.subject,
						html: null,
						text: null,
						json: {},
						type: "bee",
					},
					sender: {
						id: pathCRepresentableStep.args.sender?.id,
					},
					thumbnailUrl: pathCRepresentableStep.args.thumbnail,
					initialElement: false,
				},
			},
		});
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(
			getEdge("custom", "pathC", endCoachmark.id, {
				hideAddBtn: true,
			})
		);
		links.push(
			getEdge("custom", "pathA", "pathC", {
				hideAddBtn: true,
			})
		);
	} else if (automation.statsD?.groupedByContact?.sent > 0) {
		const pathDRepresentableStep = automation.sub_automations
			.filter((sub) => sub.name == "pathD")[0]
			.steps.filter((step) => step.name == "pathD")[0];
		events.push({
			id: "pathD",
			type: "editorNode",
			position: {
				x: 0,
				y: 0,
			},
			data: {
				showHeader: false,
				internal: true,
				name: ActionEvents()[0].name,
				desc: ActionEvents()[0].desc,
				type: "action",
				tileTitle: "app-automation-editor_events_action-1_tileTitle",
				id: mainStep.name,
				actionName: pathDRepresentableStep.description,
				baseId: "sendEmail",
				sendToLabel: I18n._translate("app-automation-editor-sendEmail-to-ppl"),
				email: {
					content: {
						id: pathDRepresentableStep.args.content.id,
						subject: pathDRepresentableStep.args.subject,
						html: null,
						text: null,
						json: {},
						type: "bee",
					},
					sender: {
						id: pathDRepresentableStep.args.sender?.id,
					},
					thumbnailUrl: pathDRepresentableStep.args.thumbnail,
					initialElement: false,
				},
			},
		});
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(
			getEdge("custom", "pathD", endCoachmark.id, {
				hideAddBtn: true,
			})
		);
		links.push(
			getEdge("custom", "pathB", "pathD", {
				hideAddBtn: true,
			})
		);
	}
	return {
		events: events,
		links: links,
	};
};
const parseFEABTestToBE = (FEEvent, connectedEdges, events) => {
	let shadows = [];
	let inTos = [];
	if (FEEvent.data.shadows) shadows = [...FEEvent.data.shadows];
	inTos = events
		.filter((e) => e.data.baseId == "loop")
		.filter((e) => e.data.goTo == FEEvent.id);
	if (inTos.length > 0) inTos = inTos.map((e) => `${e.id}_loop`);
	inTos = [...inTos, "pathA", "pathB", "winner"];
	const pathAEvent = events.filter((e) => e.id == "pathA")[0];
	const pathBEvent = events.filter((e) => e.id == "pathB")[0];
	// prepare the values of last contact id for splitting
	const avaiableArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
	const testValuesArr = avaiableArr.slice(
		0,
		parseInt(FEEvent.data.distributionTest) / 10
	);
	// split test
	let pathAValuesArr;
	let pathBValuesArr;
	let extrasArr = [];
	if (testValuesArr.length % 2 == 0) {
		pathAValuesArr = testValuesArr.slice(0, testValuesArr.length / 2);
		pathBValuesArr = testValuesArr.slice(
			testValuesArr.length / 2,
			testValuesArr.length
		);
	} else {
		const splitValue = testValuesArr.length - 1;
		pathAValuesArr = testValuesArr.slice(0, splitValue / 2);
		pathBValuesArr = testValuesArr.slice(splitValue / 2, splitValue);
		extrasArr = [testValuesArr[testValuesArr.length - 1]];
	}
	const winnerValuesArr = avaiableArr.slice(
		parseInt(FEEvent.data.distributionTest) / 10,
		avaiableArr.length
	);
	const segments = events
		.filter((e) => e.data.baseId == "segmentSelection")[0]
		.data.selectedSegs.filter((s) => s != null);
	return {
		main: [
			{
				steps: [
					{
						name: `${FEEvent.id}`,
						action: "SubAutomation.Call",
						args: {
							sub_automation: FEEvent.id,
						},
						next: "end",
						shadows: shadows,
						inTos: inTos,
					},
				],
				condition: {
					or: [
						{
							eq: {
								var: "${not(\"step\" in input.data)}",
								value: true,
							},
						},
						{
							eq: {
								var: "${input.data.step in [\"pathA\",\"pathB\",\"winner\"]}",
								value: true,
							},
						},
					],
				},
			},

			{
				condition: {
					eq: {
						var: "${input.data.step in [\"internal_winner01\"]}",
						value: true,
					},
				},
				steps: [
					{
						next: "end",
						name: "internal_winner01",
						action: "SubAutomation.Call",
						args: {
							sub_automation: "internal_winner01",
						},
					},
				],
			},
		],
		sub: [
			{
				params: [],
				steps: [
					{
						action: "Variable.Set",
						name: "lastVal",
						args: {
							lastnum: "${input.data.contact.id % 10 }",
						},
					},
					{
						action: "Variable.Set",
						name: "beforelastVal",
						args: {
							beforelastnum: "${int(input.data.contact.id % 100 / 10) }",
						},
					},
					{
						action: "Condition.Switch",
						args: {
							switch: [
								{
									condition: {
										or: [
											{
												and: [
													{
														eq: {
															value: true,
															var: "${\"step\" in input.data}",
														},
													},
													{
														eq: {
															value: "pathA",
															var: "${input.data.step}",
														},
													},
												],
											},
											{
												eq: {
													value: true,
													var: `\${lastnum in ${JSON.stringify(
														pathAValuesArr
													)}}`,
												},
											},
											{
												and: [
													{
														eq: {
															value: true,
															var: `\${lastnum in ${JSON.stringify(
																extrasArr
															)}}`,
														},
													},
													{
														eq: {
															var: "${beforelastnum % 2}",
															value: 0,
														},
													},
												],
											},
										],
									},
									steps: [
										{
											action: "SubAutomation.Call",
											name: "pathA",
											args: {
												sub_automation: "pathA",
											},
										},
									],
								},
								{
									steps: [
										{
											action: "SubAutomation.Call",
											name: "pathB",
											args: {
												sub_automation: "pathB",
											},
										},
									],
									condition: {
										or: [
											{
												and: [
													{
														eq: {
															value: true,
															var: "${\"step\" in input.data}",
														},
													},
													{
														eq: {
															value: "pathB",
															var: "${input.data.step}",
														},
													},
												],
											},

											{
												eq: {
													value: true,
													var: `\${lastnum in ${JSON.stringify(
														pathBValuesArr
													)}}`,
												},
											},

											{
												and: [
													{
														eq: {
															value: true,
															var: `\${lastnum in ${JSON.stringify(
																extrasArr
															)}}`,
														},
													},
													{
														eq: {
															var: "${beforelastnum % 2}",
															value: 1,
														},
													},
												],
											},
										],
									},
								},
								{
									condition: {
										eq: {
											value: true,
											var: `$\{lastnum in ${JSON.stringify(winnerValuesArr)}}`,
										},
									},
									steps: [
										{
											args: {
												sub_automation: "winner",
											},
											action: "SubAutomation.Call",
											name: "winner",
										},
									],
								},
							],
						},
						name: "n1234",
					},
				],
				name: FEEvent.id,
				type: "ABTest",
				segs: segments ? segments : [],
			},
			{
				params: [],
				steps: [
					{
						action: "CampaignEmail.Send",
						args: {
							sender: {
								id: pathAEvent.data.email.sender.id,
							},
							subject: pathAEvent.data.email.content.subject,
							content: {
								id: pathAEvent.data.email.content.id,
							},
						},
						name: "pathA",
						description: pathAEvent.data.actionName,
					},
					{
						args: {
							"input.data.outputs":
								"${list.concat(input.data.outputs,pathA_output)}",
							"input.data.step_trigger.pathA": "${pathA_output}",
						},
						name: "set_output",
						action: "Variable.Set",
					},
				],
				name: "pathA",
			},
			{
				name: "pathB",
				params: [],
				steps: [
					{
						name: "pathB",
						action: "CampaignEmail.Send",
						args: {
							sender: {
								id: pathBEvent.data.email.sender.id,
							},
							content: {
								id: pathBEvent.data.email.content.id,
							},
							subject: pathBEvent.data.email.content.subject,
						},
						description: pathBEvent.data.actionName,
					},
					{
						name: "set_output",
						args: {
							"input.data.outputs":
								"${list.concat(input.data.outputs,pathB_output)}",
							"input.data.step_trigger.pathB": "${pathB_output}",
						},
						action: "Variable.Set",
					},
				],
			},
			{
				params: [],
				steps: [
					{
						action: "CampaignEmail.Send",
						args: {
							sender: {
								id: pathAEvent.data.email.sender.id,
							},
							subject: pathAEvent.data.email.content.subject,
							content: {
								id: pathAEvent.data.pathCContentId
									? pathAEvent.data.pathCContentId
									: "",
							},
						},
						name: "pathC",
						description: pathAEvent.data.actionName,
					},
					{
						args: {
							"input.data.outputs":
								"${list.concat(input.data.outputs,pathC_output)}",
							"input.data.step_trigger.pathC": "${pathC_output}",
						},
						name: "set_output",
						action: "Variable.Set",
					},
				],
				name: "pathC",
			},
			{
				name: "pathD",
				params: [],
				steps: [
					{
						name: "pathD",
						action: "CampaignEmail.Send",
						args: {
							sender: {
								id: pathBEvent.data.email.sender.id,
							},
							content: {
								id: pathBEvent.data.pathDContentId
									? pathBEvent.data.pathDContentId
									: "",
							},
							subject: pathBEvent.data.email.content.subject,
						},
						description: pathBEvent.data.actionName,
					},
					{
						name: "set_output",
						args: {
							"input.data.outputs":
								"${list.concat(input.data.outputs,pathD_output)}",
							"input.data.step_trigger.pathD": "${pathD_output}",
						},
						action: "Variable.Set",
					},
				],
			},
			{
				params: [],
				steps: [
					{
						action: "SubAutomation.Call",
						description: "delay",
						name: "winner_delay",
						args: {
							sub_automation: "emit_next_step",
							params: {
								step: "internal_winner01",
								delay: convertTimeWithUnitToSeconds(MIN_DELAY),
							},
						},
					},
				],
				name: "winner",
			},
			{
				name: "internal_winner01",
				params: [],
				steps: [
					{
						args: {
							step_name: "pathA",
						},
						action: "CampaignEmail.Stats",
						name: "statsA",
					},
					{
						action: "CampaignEmail.Stats",
						name: "statsB",
						args: {
							step_name: "pathB",
						},
					},
					{
						action: "Condition.Switch",
						args: {
							switch: [
								{
									condition: {
										gt: {
											var: "${int(statsB_output.body.data.clicked)/int(statsB_output.body.data.sent)*100 - int(statsA_output.body.data.clicked)/int(statsA_output.body.data.sent)*100}",
											value: "${int(10)}",
										},
									},
									steps: [
										{
											args: {
												sub_automation: "pathD",
											},
											action: "SubAutomation.Call",
											name: "loopback",
										},
										{
											action: "Return",
											name: "return",
											return: false,
										},
									],
								},
								{
									condition: {
										gt: {
											var: "${int(statsA_output.body.data.clicked)/int(statsA_output.body.data.sent)*100 - int(statsB_output.body.data.clicked)/int(statsB_output.body.data.sent)*100}",
											value: "${int(10)}",
										},
									},
									steps: [
										{
											args: {
												sub_automation: "pathC",
											},
											action: "SubAutomation.Call",
											name: "loopback_1",
										},
										{
											action: "Return",
											name: "return_1",
											return: false,
										},
									],
								},
							],
						},
						name: "internal_winner01",
					},
					{
						action: "Condition.Switch",
						name: "fallback",
						args: {
							switch: [
								{
									condition: {
										gt: {
											value: `\${int(${moment(
												FEEvent.data.endDateFallback
											).unix()})}`,
											var: "${sys.now()}",
										},
									},
									steps: [
										{
											action: "SubAutomation.Call",
											args: {
												sub_automation: FEEvent.data.winnerFallback,
											},
											name: "loopback_default",
										},
										{
											action: "Return",
											return: false,
											name: "finished_test",
										},
									],
								},
							],
						},
					},
					{
						args: {
							sub_automation: "emit_next_step",
							params: {
								step: "internal_winner01",
								delay: DELAY_BETWEEN_CHECK_CYCLES,
							},
						},
						action: "SubAutomation.Call",
						name: "loopback_no_winner",
					},
				],
			},
		],
		reusableSubAutomations: ["emit_next_step"],
	};
};

const addWinnerEvent = (automationEvents, winnerSent) => {
	let winnerData = {};
	if (winnerSent == "pathC") {
		// copy pathContent
		winnerData = automationEvents.filter((e) => e.id == "pathA").data;
	} else {
		winnerData = automationEvents.filter((e) => e.id == "pathB").data;
	}
	const events = [];
	const links = [];
	events.push({
		id: "winner",
		type: "editorNode",
		position: {
			x: 0,
			y: 0,
		},
		data: {
			internal: true,
			name: ActionEvents()[0].name,
			desc: ActionEvents()[0].desc,
			type: "action",
			tileTitle: "app-automation-editor_events_action-1_tileTitle",
			id: winnerSent,
			actionName: winnerData.data.description,
			baseId: "sendEmail",
			sendToLabel: I18n._translate("app-automation-editor-sendEmail-to-ppl"),
			email: {
				content: {
					id: winnerData.data.email.content.id,
					subject: winnerData.data.email.content.subject,
					html: null,
					text: null,
					json: {},
					//type: "bee",
				},
				sender: {
					id: winnerData.data.email.sender?.id,
				},
				thumbnailUrl: winnerData.data.email.thumbnailUrl,
				initialElement: false,
			},
		},
	});
	const endCoachmark = getEndCoachmarkNode(0, 0);
	events.push(endCoachmark);
	links.push(
		getEdge(
			"custom",
			winnerSent == "pathC" ? "pathA" : "pathB",
			endCoachmark.id
		)
	);
	return {
		events: events,
		links: links,
	};
};

export { parseBEABTestToFE, parseFEABTestToBE, addWinnerEvent };
